import Axios from 'axios';
export default {
     
    async getOcPDF(url,codigo) {
/*
        const response = await Axios({
            url: `ordenescompra/GetOcPDF?codigoOC=`+codigo,
            method: 'GET',
             responseType: 'blob',

        });*/
        //const response = Axios.post(`licitaciones/buscarItemsFullTextExcel/`, model);
       // const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        if(!url.includes("https"))
        {
            url = url.replace("http", "https");

        
        }
        link.href = url;
        link.setAttribute('download', codigo + ".pdf"); // or any other extension
        document.body.appendChild(link);
        link.click();
      //  window.open(url, '_blank'); 
    },
    async getItemsOCExcel(codigo) {

        const response = await Axios({
            url: `ordenescompra/GetItemsOCExcel?codigoOC=`+codigo,
            method: 'GET',
             responseType: 'blob',

        });
        //const response = Axios.post(`licitaciones/buscarItemsFullTextExcel/`, model);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', codigo + ".xlsx"); // or any other extension
        document.body.appendChild(link);
        link.click();
    }
    ,
    async getMaterialesExcel() {

        const response = await Axios({
            url: `ordenescompra/GetMaterialesExcel`,
            method: 'GET',
             responseType: 'blob',

        });
        //const response = Axios.post(`licitaciones/buscarItemsFullTextExcel/`, model);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', "Materiales" + ".xlsx"); // or any other extension
        document.body.appendChild(link);
        link.click();
    }
    ,
    
    async getPreciosExcel() {

        const response = await Axios({
            url: `ordenescompra/GetPreciosExcel`,
            method: 'GET',
             responseType: 'blob',

        });
        //const response = Axios.post(`licitaciones/buscarItemsFullTextExcel/`, model);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', "Precios" + ".xlsx"); // or any other extension
        document.body.appendChild(link);
        link.click();
    }
    ,
    createMaterialesExcel(model)
    {
        //let query = `model=` + model;
        return Axios.post(`ordenescompra/createMaterialMasivo/`,model);

    },
    createPreciosExcel(model)
    {
        //let query = `model=` + model;
        return Axios.post(`ordenescompra/createPreciosMasivo/`,model);

    },
    
    findoc(codigo) {
        let query =  `codigoOC=` + codigo
        return Axios.get(`ordenescompra/GetOCDetail/?${query}`);

    },
    findProducto(search) {
        let query =  `search=` + search
        return Axios.get(`ordenescompra/GetArticulo/?${query}`);

    },
    getAllMateriales(paging,search) {
        let query =  paging + `&search=` + search
        return Axios.get(`ordenescompra/GetAllMateriales/?${query}`);

    },
    getAllPrecios(paging,search) {
        let query =  paging + `&search=` + search
        return Axios.get(`ordenescompra/GetAllPrecios/?${query}`);

    },
    getAllContratos(paging,search) {
        let query =  paging + `&search=` + search
        return Axios.get(`ordenescompra/GetAllContratos/?${query}`);

    },
    
    getArticuloByCodigo(search) {
        let query =  `codigo=` + search
        return Axios.get(`ordenescompra/GetArticuloByCodigo/?${query}`);

    },
    getPrecioArticulo(codigoOC, codigoProductoIntegracion) {
        let query =  `codigoOC=` + codigoOC +`&codigoProductoIntegracion=` + codigoProductoIntegracion
        return Axios.get(`ordenescompra/GetPrecioArticulo/?${query}`);

    },
    updateInfoIntegracion(model) {
        return Axios.post(`ordenescompra/UpdateInfoIntegracion/`, model);
      },
    updateInfoIntegracionDetalle(model) {
        return Axios.post(`ordenescompra/UpdateInfoIntegracionDetalle/`, model);
      },
    updateEstadoIntegracion(model) {
        return Axios.post(`ordenescompra/UpdateEstadoIntegracion/`, model);
      },
    updateMaterial(model) {
    return Axios.post(`ordenescompra/UpdateMaterial/`, model);
    },
    createMaterial(model) {
        return Axios.post(`ordenescompra/CreateMaterial/`, model);
    },
    updatePrecio(model) {
    return Axios.post(`ordenescompra/UpdatePrecio/`, model);
    },
    createPrecio(model) {
    return Axios.post(`ordenescompra/CreatePrecio/`, model);
    },
    getHistorialOC(codigo) {
        let query =  `codigo=` + codigo
        return Axios.get(`ordenescompra/GetHistorialOC/?${query}`);

    },
    getOCDashboard(estado) {
        let query =  `estado=` + estado
        return Axios.get(`ordenescompra/GetOCDashboard/?${query}`);

    },
    getOCDashboardFechas(estado, fechaIni, fechaFin) {
        let query =  `estado=` + estado +`&fechaIni=` + fechaIni+`&fechaFin=` + fechaFin;
        return Axios.get(`ordenescompra/GetOCDashboardFechas/?${query}`);

    },
    getOCDashboardPaging(paging, search, estado) {
        let query = paging + `&busqueda=` + search + `&estado=` + estado;
        return Axios.get(`ordenescompra/GetOCDashboardPaginado/?${query}`);
    },
    getOCDashboardPagingFechas(paging, search, estado, fechaIni, fechaFin) {
        let query = paging + `&busqueda=` + search + `&estado=` + estado+`&fechaIni=` + fechaIni+`&fechaFin=` + fechaFin;
        return Axios.get(`ordenescompra/getOCDashboardPagingFechas/?${query}`);
    },
    getOCDashboardHistoricoPaging(paging, search, estado,rutProveedor) {
        let query = paging + `&busqueda=` + search + `&estado=` + estado + `&rutProveedor=` + rutProveedor;
        return Axios.get(`ordenescompra/GetOCDashboardHistoricoPaginado/?${query}`);
    },
    getOCDashboardHistoricoPagingFechas(paging, search, estado,rutProveedor, fechaIni, fechaFin) {
        let query = paging + `&busqueda=` + search + `&estado=` + estado + `&rutProveedor=` + rutProveedor+`&fechaIni=` + fechaIni+`&fechaFin=` + fechaFin;
        return Axios.get(`ordenescompra/GetOCDashboardHistoricoPaginadoFechas/?${query}`);
    },
    getEjecutivosPaging(paging, search) {
        let query = paging + `&search=` + search;
        return Axios.get(`ordenescompra/GetEjecutivos/?${query}`);
    },
    getRegionesEjecutivo(idUsuario) {
        let query =  `id=` + idUsuario
        return Axios.get(`ordenescompra/GetRegionesEjecutivo/?${query}`);

    },
    async createEjecutivo(model)
    {
        //let query = `model=` + model;
        return Axios.post(`ordenescompra/CreateEjecutivo/`,model);

    },
    async updateEjecutivo(model)
    {
        //let query = `model=` + model;
        return Axios.post(`ordenescompra/UpdateEjecutivo/`,model);

    },
    async activateEjecutivo(model)
    {
        //let query = `model=` + model;
        return Axios.post(`ordenescompra/ActivateEjecutivo/`,model);

    },
    createRegionEjecutivo(region,idUsuario)
    {
      let query = `region=` + region +`&idUsuario=` + idUsuario;
      return Axios.post(`ordenescompra/CreateRegionEjecutivo/?${query}`);
    },
    deleteRegionesEjecutivo(id)
    {
      let query = `id=` + id;
      return Axios.post(`ordenescompra/DeleteRegionesEjecutivo/?${query}`);
    },
    deleteAllRegionesEjecutivo(idUsuario)
    {
      let query = `idUsuario=` + idUsuario;
      return Axios.post(`ordenescompra/DeleteAllRegionesEjecutivo/?${query}`);
    },
    createComentario(codigo,comentario,tipo)
    {
      let query = `codigoExterno=` + codigo +`&comentario=` + comentario + `&tipo=` +tipo;
      return Axios.post(`ordenescompra/CreateComentario/?${query}`);
    },
    findComentarios(idOc) {
        let query =  `idOc=` + idOc
        return Axios.get(`ordenescompra/FindComentarios/?${query}`);

    },
    getEvolucionOcCliente()
  {
     
   return Axios.get(`ordenescompra/GetEvolucionOcCliente/`);
  },
  getMesesBusqueda()
  {
     
   return Axios.get(`ordenescompra/GetMesesBusqueda/`);
  },
  getEvolucionOcClienteMensual(mesAnio)
  {
    let query =  `mesAnio=` + mesAnio
     
   return Axios.get(`ordenescompra/GetEvolucionOcClienteMensual/?${query}`);
  },
  getEvolucionOcClienteMensualRegion(mesAnio)
  {
    let query =  `mesAnio=` + mesAnio
     
   return Axios.get(`ordenescompra/GetEvolucionOcClienteMensualRegion/?${query}`);
  },
    async getOCDashboardExcel(estado) {
        let query =  `estado=` + estado
        const response = await Axios({
            url: `ordenescompra/GetOCDashboardExcel/?${query}`,
            method: 'GET',
             responseType: 'blob',

        });
        //const response = Axios.post(`licitaciones/buscarItemsFullTextExcel/`, model);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', "OC_"+estado + ".xlsx"); // or any other extension
        document.body.appendChild(link);
        link.click();
    }
    ,
    async getOCDashboardExcelFechas(estado, fechaIni, fechaFin) {
        let query =  `estado=` + estado +`&fechaIni=` + fechaIni+`&fechaFin=` + fechaFin;
        const response = await Axios({
            url: `ordenescompra/GetOCDashboardExcelFechas/?${query}`,
            method: 'GET',
             responseType: 'blob',

        });
        //const response = Axios.post(`licitaciones/buscarItemsFullTextExcel/`, model);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', "OC_"+estado + ".xlsx"); // or any other extension
        document.body.appendChild(link);
        link.click();
    }
    ,
    async getOCDashboardHistoricoExcel(estado, rutProveedor) {
        let query =  `estado=` + estado + `&rutProveedor=` + rutProveedor
        const response = await Axios({
            url: `ordenescompra/GetOCDashboardHistoricoExcel/?${query}`,
            method: 'GET',
             responseType: 'blob',

        });
        //const response = Axios.post(`licitaciones/buscarItemsFullTextExcel/`, model);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', "OC_historico_resumen.xlsx"); // or any other extension
        document.body.appendChild(link);
        link.click();
    }
    ,
    async buscarItemsOCFullTextExcel(rutProveedor) {
        let query =  `rutProveedor=` + rutProveedor
        const response = await Axios({
            url: `ordenescompra/buscarItemsOCFullTextExcel/?${query}`,
            method: 'POST',
            responseType: 'blob'           

        });
        //const response = Axios.post(`licitaciones/buscarItemsFullTextExcel/`, model);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', "BusquedaOC" + ".xlsx"); // or any other extension
        document.body.appendChild(link);
        link.click();
    },
    async buscarItemsOCFullTextExcelFechas(rutProveedor, fechaIni, fechaFin) {
        let query =  `rutProveedor=` + rutProveedor+`&fechaIni=` + fechaIni+`&fechaFin=` + fechaFin;
        const response = await Axios({
            url: `ordenescompra/buscarItemsOCFullTextExcelFechas/?${query}`,
            method: 'POST',
            responseType: 'blob'           

        });
        //const response = Axios.post(`licitaciones/buscarItemsFullTextExcel/`, model);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', "BusquedaOC" + ".xlsx"); // or any other extension
        document.body.appendChild(link);
        link.click();
    },
    
}